const locationPk = {
	selector: {
		districtLabel: 'ضلع',
		upazillaLabel: 'تحصیل',
		bazarLabel: 'بازار',
		districtSearchPlaceholder: 'ضلع تلاش کریں...',
		upazillaSearchPlaceholder: 'تحصیل تلاش کریں...',
		bazarSearchPlaceholder: 'بازار تلاش کریں...'
	},
	popup: {
		title: 'اپنا علاقہ منتخب کریں',
		instruction: 'گرامین بازار استعمال کرنے کے لیے اپنا ضلع، تحصیل اور بازار منتخب کریں',
		chooseDistrict: 'ضلع منتخب کریں',
		chooseUpazilla: 'تحصیل منتخب کریں',
		chooseBazar: 'بازار منتخب کریں',
		districtSearchPlaceholder: 'ضلع تلاش کریں...',
		upazillaSearchPlaceholder: 'تحصیل تلاش کریں...',
		bazarSearchPlaceholder: 'بازار تلاش کریں...',
		selectedPrefix: 'منتخب:',
		confirm: 'تصدیق کریں'
	}
};

export default locationPk;


